import { initReactI18next } from "react-i18next";

import i18n from "i18next";

import deTranslation from "../locales/de/translation.json";
import enTranslation from "../locales/en/translation.json";
import esTranslation from "../locales/es/translation.json";
import frTranslation from "../locales/fr/translation.json";
import jaTranslation from "../locales/ja/translation.json";
import koTranslation from "../locales/ko/translation.json";
import ptTranslation from "../locales/pt-br/translation.json";
import viTranslation from "../locales/vi/translation.json";
import zhTranslation from "../locales/zh-cn/translation.json";

// the translations
const resources = {
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  de: {
    translation: deTranslation,
  },
  es: {
    translation: esTranslation,
  },
  ja: {
    translation: jaTranslation,
  },
  ko: {
    translation: koTranslation,
  },
  pt: {
    translation: ptTranslation,
  },
  vi: {
    translation: viTranslation,
  },
  zh: {
    translation: zhTranslation,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
